






























































































export default function (Component) {
  Component.options.__source = "src/components/d2-container-child-subprojectQuotation-select/index.vue"
}
